import { IconType } from "react-icons";
import { TbAward, TbClockCheck, TbDiamond } from "react-icons/tb";

interface FeatureType {
    icon: IconType;
    title: {
        ar: string;
        en: string;
    };
    content: {
        ar: string;
        en: string;
    };
}

export const features: FeatureType[] = [
    {
        icon: TbClockCheck,
        title: {
            ar: "الالتزام",
            en: "Commitment",
        },
        content: {
            ar: "نلتزم بالشفافية والمصداقية في جميع تعاملاتنا، ونحرص على تلبية متطلبات عملائنا وفق الجداول الزمنية المتفق عليها.",
            en: "We are committed to transparency and reliability in all our operations, ensuring timely delivery that meets our clients’ expectations.",
        },
    },
    {
        icon: TbDiamond,
        title: {
            ar: "الجودة",
            en: "Quality",
        },
        content: {
            ar: "نحرص على استيراد منتجات عالية الجودة من موردين معتمدين، بما يضمن مطابقتها للمواصفات والمعايير الدولية.",
            en: "We carefully source high-quality products from trusted suppliers to ensure compliance with international standards.",
        },
    },
    {
        icon: TbAward,
        title: {
            ar: "الاحترافية",
            en: "Professionalism",
        },
        content: {
            ar: "نعمل بفريق متخصص وخبرة عملية تضمن تنفيذ خدمات الاستيراد والتوريد بكفاءة واحترافية عالية.",
            en: "Our experienced team ensures professional execution of import and supply services with high efficiency.",
        },
    },
];
